import { render, staticRenderFns } from "./DdsDefenderSwitch.vue?vue&type=template&id=e8f67216&scoped=true&"
import script from "./DdsDefenderSwitch.vue?vue&type=script&lang=js&"
export * from "./DdsDefenderSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DdsDefenderSwitch.vue?vue&type=style&index=0&id=e8f67216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f67216",
  null
  
)

export default component.exports